// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedQuizType {
  Freeform: {"enum_constant":"Freeform"};
  MultiChoice: {"enum_constant":"MultiChoice"};
  MultiChoiceMany: {"enum_constant":"MultiChoiceMany"};
  Pool: {"enum_constant":"Pool"};
  PoolMany: {"enum_constant":"PoolMany"};
}

export type QuizTypeId = keyof IParsedQuizType;
export type QuizTypeData = IParsedQuizType[QuizTypeId];
const data: QuizTypeData[] = [{"enum_constant":"Freeform"},{"enum_constant":"MultiChoice"},{"enum_constant":"MultiChoiceMany"},{"enum_constant":"Pool"},{"enum_constant":"PoolMany"}];
export default data;
